export enum DashboardFilterBy {
  ANNUALLY = 'ANNUALLY',
  MONTHLY = 'MONTHLY',
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  LASTYEARS = 'LASTYEARS',
  CUSTOM = 'CUSTOM',
}
